export default __webpack_public_path__ + "static/media/OLAP.e5cb7fcd.png";